class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.hiddenSearchResults = this.querySelector('#search_hide_content');
    this.clearButton = document.getElementById('clearButton');
    this.lastSearchTerm = '';
    this.clearButton.addEventListener('click', () => this.clearSearch());
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    this.toggleClearButton();
    if (!searchTerm.length) {
      this.close();
      this.lastSearchTerm = '';
      return;
    }

    if (searchTerm === this.lastSearchTerm) return;

    this.lastSearchTerm = searchTerm;
    console.log(`Searching for: "${searchTerm}"`);
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          this.close();
          throw new Error(`Search request failed with status: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const resultsContainer = doc.querySelector('#shopify-section-predictive-search');

        if (!resultsContainer || !resultsContainer.innerHTML.trim()) {
          console.log(`No results for: "${searchTerm}"`);
          this.tryPartialMatch(searchTerm);
          return;
        }

        const highlightedMarkup = this.highlightMatches(resultsContainer.innerHTML, searchTerm);
        this.predictiveSearchResults.innerHTML = highlightedMarkup;
        this.open();
      })
      .catch((error) => {
        console.error(`Error fetching search results: ${error.message}`);
        this.close();
      });
  }

  tryPartialMatch(searchTerm) {
    const partialTerm = searchTerm.split(' ').slice(0, -1).join(' ').trim();
    if (partialTerm) {
      console.log(`Trying partial match for: "${partialTerm}"`);
      this.getSearchResults(partialTerm);
    } else {
      console.log('No further partial matches possible.');
      this.close();
    }
  }

  toggleClearButton() {
    this.clearButton.style.display = this.input.value ? 'inline' : 'none';
  }

  clearSearch() {
    this.input.value = '';
    this.lastSearchTerm = '';
    this.toggleClearButton();
    this.close();
    this.input.focus();
  }

  highlightMatches(markup, searchTerm) {
    const regex = new RegExp(`(${searchTerm.split(/\s+/).join('|')})`, 'gi');
    const parser = new DOMParser();
    const doc = parser.parseFromString(markup, 'text/html');
    const elementsToHighlight = doc.querySelectorAll('.col_1_content_item h3');

    elementsToHighlight.forEach((element) => {
      const originalText = element.textContent;
      const highlightedText = originalText.replace(regex, (match) => `<strong>${match}</strong>`);
      element.innerHTML = highlightedText;
    });

    return doc.body.innerHTML;
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.hiddenSearchResults.style.display = 'none';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.hiddenSearchResults.style.display = 'block';
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
